import * as React from 'react';
import { IOutputValue, IOutputGroup, DOMHelper } from '../../helpers';
import { DEFAULT_JOURNEY_ID } from '../../constants';
import {
    DialogFooter,
    Button, ButtonType,
    TextField, Toggle
} from 'office-ui-fabric-react';

interface IMoveHandler {
    drag: (e, index: number | string) => void;
    drop: (e, toIndex: number | string) => void;
    allowDrop: (e, i: number | string) => void;
}

interface IProps {
	outputs: IOutputValue[];
    groups: IOutputGroup[];
    closeDialog: (save: boolean) => void;
    updateGroup: (groupName: string, outputId: string) => void;
    updateShowOnSummary: (show: boolean, outputId: string) => void;
    overId: string;
    fromId: string;
    overGroupIndex: number;
    fromGroupIndex: number;
    moveHandler: IMoveHandler;
    groupMoveHandler: IMoveHandler;
    isSharedJourney: boolean;
}

export class SummaryDialog extends React.Component<IProps, any> {

    outputHtml = (output: IOutputValue, i: number): JSX.Element => {

        let { overId, fromId, moveHandler, updateGroup, updateShowOnSummary, isSharedJourney } = this.props;
        let { Id, Name, Group, DisplayOnSummary, componentId } = output;
        let classNames: string[] = ['summary-output', 'clearfix'];

        if (overId === Id)
            classNames.push('drag-over');
        if (fromId === Id)
            classNames.push('drag-from');

        let disableDisplayOnSummaryToggle: boolean = isSharedJourney && !!componentId && !!(componentId.length);

        return <div key={ Id }
            className={ classNames.join(' ') }
            onDrop={ (e) => moveHandler.drop(e, Id) }
            onDragOver={ (e) => moveHandler.allowDrop(e, Id) }>
        
            <Button buttonType={ ButtonType.icon } icon="Move"
                title="Move output"
                className="output-move"
                draggable={ true }
                onDragStart={ (e) => moveHandler.drag(e, Id) }
                onDragEnd={ (e) => moveHandler.drop(e, null) }
                tabIndex={-1} />

            <TextField tabIndex={-1} label="Name" value={ Name || '' } readOnly={ true } />

            <TextField label="Group" value={ Group || '' } onBlur={ e => updateGroup(e.currentTarget.value, Id) } placeholder="(No group)" 
                disabled={!!output.IsRepeatableBlockOutput} />

            <div className="summary-output-toggle">
                <label className="ms-Label">Show</label>
                <Toggle 
                    checked={ DisplayOnSummary } 
                    disabled={ disableDisplayOnSummaryToggle }
                    onChanged={ (val) => {
                        if(!disableDisplayOnSummaryToggle) {
                            updateShowOnSummary(val, Id);
                        }
                    }}
                />
            </div>

        </div>;

    }

    groupHtml = (group: IOutputGroup, i: number): JSX.Element => {

        let { groupMoveHandler, outputs, overGroupIndex, fromGroupIndex, fromId } = this.props;
        let outputElements: JSX.Element[] = group.outputs
            .map(id => outputs.filter(o => o.Id === id)[0])
            .filter(o => !!o) //filter out null/undefined outputs, which will be outputs from a repeatable control block
            // Outputs Html
            .map(this.outputHtml);

        let classNames: string[] = ['output-group'];

        if (overGroupIndex === i)
            classNames.push('over-group');
        if (fromGroupIndex === i)
            classNames.push('from-group');
        if (fromId && group.outputs.indexOf(fromId) < 0)
            classNames.push('drop-disallowed');

        return <div className={ classNames.join(' ') } key={ group.name }
            onDrop={ (e) => groupMoveHandler.drop(e, i) }
            onDragOver={ (e) => groupMoveHandler.allowDrop(e, i) }>
        
            <Button buttonType={ ButtonType.icon } icon="Move"
                title="Move output"
                className="output-move"
                tabIndex={-1}
                draggable={ true }
                onDragStart={ (e) => groupMoveHandler.drag(e, i) }
                onDragEnd={ (e) => groupMoveHandler.drop(e, null) } />

            <h4>{ group.name || '(Ungrouped)' }</h4>
            { outputElements }

        </div>;

    }

	public componentDidMount() {
        DOMHelper.setDropdownPropertyTabIndex();
	}

	public render () {

		let { closeDialog, groups } = this.props;
        
        // Grouped outputs
        let groupElements: JSX.Element[] = groups
            .filter(g => g.outputs.length)
            .map(this.groupHtml);

		return <div>

            { groupElements }
                
            <DialogFooter>
                <Button buttonType={ ButtonType.normal } onClick={ () => closeDialog(false) }>Cancel</Button>
                <Button buttonType={ ButtonType.primary } onClick={ () => closeDialog(true) }>Save</Button>
            </DialogFooter>

        </div>;

	}

}


// WEBPACK FOOTER //
// ./source/ts/components/layout/summary-dialog.tsx